import { isProduction } from './env';
import { webConfig } from './webConfig';

/**
 * Return the fully qualified Hive domain with protocol.
 */
export function getHiveEndpointFromEnv(): string {
    if (process.env.FIRESTORE_EMULATOR_HOST) {
        return 'http://127.0.0.1:7001';
    }

    // TODO: enable this once we have a local Hive V2 setup
    // if (isDevelopment) {
    //     return 'http://localhost:6222';
    // }

    // The V2 public endpoint is backwards compatible with v1, but we need to test in
    // staging before we move production traffic to it.
    if (isProduction) {
        return `https://${webConfig.services.content.host}`;
    }

    return `https://v2-${webConfig.services.content.host}`;
}

/**
 * Return the fully qualified URL for Hive file storage.
 * This _cannot_ differ between V1/V2 as it would break file access between the two versions.
 */
export function getHiveFileBaseURL(): string {
    if (process.env.FIRESTORE_EMULATOR_HOST) {
        return 'http://127.0.0.1:7001';
    }

    return `https://${webConfig.services.content.host}`;
}
